import { memo, useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import IntlMessages from '../Message/IntlMessages';
import DangerousMessage from '../Message/DangerousMessage'
import { alertError } from "redux/reducers/master";

const AcceptFactsheet = ({
  close, state, actions, ...modalProps
}) => {
  const dispatch = useDispatch();
  const [accepting, setAccepting] = useState(false);

  async function onAccept() {
    if (accepting) return;
    setAccepting(true);

    try {
      if (actions?.onAccept) {
        await Promise.resolve(actions.onAccept());
      }
      // Close only after async accept finishes successfully
      close();
    } catch (err) {
      console.error("[AcceptFactsheet] onAccept error:", err);
      dispatch(alertError(err));
      // Do not close to allow user to retry
    } finally {
      setAccepting(false);
    }
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.factsheet.header" />
            </h5>
            <Button className="btn button-ktb-close" onClick={close} disabled={accepting}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body overflow-x-hidden color-gray-strong">
            <DangerousMessage.Span className="custom-message-1" html={state.factsheetPopupMessage}/>
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6">
                <div className="d-grid">
                  <Button
                    data-accept-btn
                    type="primary"
                    className="btn button-ktb-main"
                    onClick={onAccept}
                    disabled={accepting}
                    loading={accepting}
                  >
                    {state.factsheetPopupType === 'information' 
                      ? <IntlMessages id="global.acknowledge" />
                      : <IntlMessages id="global.accept-and-agree" />
                    }
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default memo(AcceptFactsheet);